<template>
    <div class="app_modal" :class="(isOpen) ? 'open' : ''">
        <div class="modal_inner" :data-type="type">
            <div class="modal_title">
                {{ modalParams[type]["title"] }}
            </div>
            <div class="modal_content" v-if="type == 'country'">
                <div class="input_glass"></div>
                <input type="text" id="CountriesInput" autocomplete="off" placeholder="eg: France" class="modal_input" v-on:keyup="searchInputKeyup($event)" @focus="focusInput($event)" @blur="blurInput()" />
                <div class="modal_suggestions" :class="(displayAutocomplete) ? 'displayed' : ''">
                    <nuxt-link class="suggestion_country" :to="'/country/'+countryObj.iso3" v-for="(countryObj, countryIndex) in autocompleteCountries">
                        {{ countryObj.country_name }}
                    </nuxt-link>
                </div>
            </div>
            <div class="modal_content" v-else-if="type == 'dataset'">
                <nuxt-link to="/dataset/global-profit" class="modal_bt">
                    <span>Global profit shifting by multinational enterprises</span>
                </nuxt-link>
                <nuxt-link to="/dataset/offshore-financial" class="modal_bt">
                    <span>Offshore financial wealth</span>
                </nuxt-link>
                <nuxt-link to="/dataset/offshore-real-estate" class="modal_bt">
                    <span>Offshore real estate wealth</span>
                </nuxt-link>
                <nuxt-link to="/dataset/effective-tax" class="modal_bt">
                    <span>Effective tax rates on capital and labor</span>
                </nuxt-link>
            </div>
            <div class="modal_backbt" @click="closeModal()">
                Go back
            </div>
        </div>
    </div>
</template>

<script>

import {_} from 'underscore'
var slugify = require("underscore.string/slugify")

export default {
    props: {
        countries: {
            default: function () {
                return []
            }
        }
    },
    data: function () {
        return {
            modalParams: {
                "country":{
                    title: "Choose a country"
                },
                "dataset":{
                    title: "Choose a dataset"
                }
            },
            isOpen: false,
            type: "country",
            displayAutocomplete: false,
            autocompleteCountries: []
        }
    },
    mounted: function () {
    },
    methods: {
        openModal: function (modalType){
            this.type = modalType;
            this.isOpen = true;
        },

        closeModal: function (){
            this.isOpen = false;
        },

        searchInputKeyup: function (evt){
            var self = this;
            var inputValue = evt.target.value;
            this.performAutocomplete(inputValue);
        },

        focusInput: function (evt){
            var inputValue = evt.target.value;
            this.performAutocomplete(inputValue);
        },

        blurInput: function (){
            var self = this;
            var $input = document.querySelector("#CountriesInput");
            setTimeout(function(){
                self.displayAutocomplete = false;
            }, 200)
            $input.value = "";
        },

        performAutocomplete: function (inputValue){
            this.displayAutocomplete = true;

            var filteredCountries = _.filter(this.countries, function (o){
                return o.country_name.toLowerCase().includes(inputValue.toLowerCase());
            })

            this.autocompleteCountries = JSON.parse(JSON.stringify(filteredCountries));
            console.log("filteredCountries", filteredCountries);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~assets/scss/_variables.scss";
@import "~assets/scss/_browsers.scss";

.app_modal{
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    z-index: 10000;
    display: none;
    &:before{
        content: "";
        position: absolute;
        right: 0px;
        top: 0px;
        transform: translate(0, 0);
        background: url("/images/visual-asset-orange.png") no-repeat 0 0;
        background-size: 100% 100%;
        width: 1096px;
        height: 661px;
    }
    &.open{
        display: block;
    }
    .modal_inner{
        width: 590px;
        position: absolute;
        left: 50%;
        top: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
        .modal_title{
            color: $colorBlue;
            font-size: 20px;
            letter-spacing: 2px;
            text-align: left;
        }
        .modal_backbt{
            margin-top: 24px;
            height: 24px;
            line-height: 24px;
            background: $colorBlue;
            border-radius: 32px;
            color: #fff;
            display: inline-block;
            width: 105px;
            text-indent: 10px;
            cursor: pointer;
            font-size: 14px;
            position: relative;
            &:before{
                content: "";
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translate(0, -50%);
                background: url("/images/arrow-back.svg") no-repeat 0 0;
                background-size: 100% 100%;
                width: 21px;
                height: 20px;
            }
        }
        .modal_content{
            position: relative;
            .input_glass{
                position: absolute;
                right: 26px;
                top: 26px;
                background: url("/images/glass.svg") no-repeat 0 0;
                background-size: 100% 100%;
                width: 20px;
                height: 20px;
            }
            .modal_bt{
                height: 60px;
                width: 100%;
                display: block;
                text-decoration: none;
                background: $colorBlue;
                color: #fff;
                border-radius: 32px;
                border: 0px;
                margin-top: 16px;
                text-align: left;
                padding: 0 40px;
                position: relative;
                span{
                    position: absolute;
                    left: 40px;
                    top: 50%;
                    font-size: 20px;
                    line-height: 26px;
                    transform: translate(0, -50%);
                }
                &:after{
                    content: "";
                    position: absolute;
                    right: 20px;
                    top: 50%;
                    transform: translate(0, -50%) rotate(180deg);
                    background: url("/images/arrow-back.svg") no-repeat;
                    background-size: 100% 100%;
                    width: 21px;
                    height: 20px;
                }
            }
            .modal_input{
                height: 60px;
                background: #EEF1F6;
                padding: 0 30px;
                border: 2px solid #BAC6DF;
                border-radius: 32px;
                font-size: 20px;
                color: $colorBlack;
                margin-top: 6px;
                width: 100%;
            }
            .modal_suggestions{
                position: absolute;
                top: 70px;
                left: 0px;
                width: 100%;
                border: 1px solid $colorBlue;
                background: $colorBlue;
                max-height: 300px;
                overflow: auto;
                z-index: 100;
                padding: 10px;
                border-radius: 32px;
                display: none;
                text-align: left;
                &.displayed{
                    display: block;
                }
                .suggestion_country{
                    display: block;
                    color: #fff;
                    height: 40px;
                    padding: 0 20px;
                    line-height: 40px;
                    font-size: 20px;
                    text-decoration: none;
                    position: relative;
                    &:hover{
                        background: $colorBlueHover;
                    }
                    &:after{
                        content: "";
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translate(0, -50%) rotate(180deg);
                        background: url("/images/arrow-back.svg") no-repeat;
                        background-size: 100% 100%;
                        width: 21px;
                        height: 20px;
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// components/appModal.vue